import { gql } from "@apollo/client";

export default gql`
	query ($trackingNumber: String!) {
		inferCourierFromTrackingNumber(trackingNumber: $trackingNumber)
	}
`;
